import React from 'react'
import { useDispatch } from 'react-redux'
import { Flex } from '../../lib/components'
import { AccountChangePasswordPresenter } from './account-change-password-presenter'
import { adminAccountChangePasswordSchema } from '../../lib/utils/schema'
import { userServices } from '../../services'
import { showBanner } from '../../global-state/banner-slice'
import './account-change-password.scss'

const initialValues = {
  currentPassword: '',
  newPassword: '',
  newPasswordConfirmation: '',
}

const AccountChangePasswordContainer = () => {
  const dispatch = useDispatch()

  const handleSubmit = async (val: typeof initialValues) => {
    const res = await userServices.changeAdminPassword({
      currentPassword: val.currentPassword,
      newPassword: val.newPassword,
    })
    if (res?.status === 200) {
      dispatch(
        showBanner({
          text: 'Password updated. Other sessions have been signed out.',
          variant: 'success-banner',
        }),
      )
    } else {
      const msg =
        (res?.data as { message?: string } | undefined)?.message ||
        'Could not update password. Please try again.'
      dispatch(showBanner({ text: msg, variant: 'error-banner' }))
    }
  }

  return (
    <Flex variant='column' classes={['account-change-password-page', 'align-center']}>
      <AccountChangePasswordPresenter
        initialValues={initialValues}
        handleFormSubmit={handleSubmit}
        validationSchema={adminAccountChangePasswordSchema}
      />
    </Flex>
  )
}

export { AccountChangePasswordContainer }
